const ALLOWED_URL_PARAMS = ['utm_campaign', 'utm_source', 'utm_medium'];

export const UTM_FOR_SIMILAR_VEHICLES_RECOMMENDATIONS = { utm_campaign: 'similar-vehicles' };

export const getAllowedUrlParams = (urlParams = {}) => {
	const keys = Object.keys(urlParams);
	if (!keys.length) return {};

	return keys
		.filter((key) => ALLOWED_URL_PARAMS.includes(key))
		.reduce((allowedParams, key) => {
			allowedParams[key] = urlParams[key];
			return allowedParams;
		}, {});
};
